import { generateAssetCdnUrl } from '@tickled-media/web-components.tm-helpers';
import React, {Fragment} from 'react';
import cx from '../../../styles';

const RecipeList = (props) => {
	return (
		<Fragment>
			{
				props.recipes && 
				props.recipes.map((recipe) => {
					return (
						<div key={recipe.id} className={cx('each-recipe')} onClick={() => props.clickHandler(recipe.slug, recipe.id)}>
							<a href={`/recipe/${recipe.slug}/${recipe.id}`} onClick={(e) => props.isShowLess ? null : e.preventDefault()} className={cx('recipe-image')} aria-label="Click to view recipe detail">
								<img src={recipe.images ? recipe.images[0] : generateAssetCdnUrl("community-theasianparent/assets", "food_placeholder.png")} alt={recipe.label} loading="lazy" />
							</a>
							<a href={`/recipe/${recipe.slug}/${recipe.id}`} onClick={(e) => props.isShowLess ? null : e.preventDefault()} className={cx('recipe-details-wrap')} aria-label="Click to view recipe detail">
								<span className={cx('recipe-details')}>
									<span className={cx('recipe-title')}>
										{recipe.label}
									</span>
									<span className={cx('recipe-tags')}>
										{
											!props.isShowLess && recipe.tags
											?
												recipe.tags.map((tag) => {
													return (
														<span key={tag.label}>
															{tag.label}
														</span>
													)
												})
											:
												<span>
													{recipe.tags && recipe.tags[0].label}
												</span>
										}
									</span>
									<span className={cx('recipe-properties')}>
										{
											recipe.properties &&
											recipe.properties.map((property, index) => {
												if(props.isShowLess && index < 3){
													return (
														<span key={property.key} className={cx('each-property')}>
															<img src={property.icon} alt={property.key} loading="lazy" />
															<span>{property.label}</span>
														</span>
													)
												}
												else if(!props.isShowLess){
													return (
														<span key={property.key} className={cx('each-property')}>
															<img src={property.icon} alt={property.key} loading="lazy" />
															<span>{property.label}</span>
														</span>
													)
												}
												return false
											})
										}
									</span>
								</span>
							</a>
						</div>
					)
				})
			}
		</Fragment>
	)
}

export default RecipeList;